import { usePagination } from "../../../context/PaginationContext";
import { Tooltip } from "antd";
const Status = (props) => {
  const { pagination, setPagination } = usePagination();
    const {wplyw} = props
  // Color mapping for statuses
  const statusColor = {
    blank: '#D9D9D9',
    warning: '#FBB55E',
    error: '#DC0202',
    success: '#52C41A'
  };

  // Example statuses
  const statusMap = [
    {
      index: 1,
    name: 'Dane wpływu',
      desc: 'Informuje o stanie wypełnienia podstawowych danych wpływu.',
    },
    {
        index: 2,
      name: 'Osoby',
      desc: 'Informuje o etapie dodania osób do wpływu.',
    },
    {
        index: 3,
      name: 'Podział kwot',
      desc: 'Status wypełniania zakładki Kwoty i poprawność danych.',
    },
    {
        index: 4,
      name: 'Rachunki',
      desc: 'Status wypełnienia zakładki Rachunki i poprawność danych.',
    },
    {
        index: 5,
      name: 'Przelewy',
      desc: 'Status zatwierdzenia przelewów.',
    },
  ];
  return (
      <div style={{ display: 'flex', gap: '5px' }}>
      {statusMap.map((status, index) => {
          return (
            <Tooltip placement="top" title={status.desc}>
          <div
            key={index} // Use index or a unique identifier if available
            style={{
              width: '40px',
              height: '30px',
              backgroundColor: statusColor[wplyw.status[status.index]['status']], // Dynamically set color
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: 'white', // Text color to contrast with background
              borderRadius: '0'
            }}
          >
            <span style={{ fontSize: '12px' }}>
              {status.index}
            </span>
          </div>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default Status;
